export const fieldValidation = {
  required: '{{fieldName}} is required',
  pattern: '{{fieldName}} is invalid',
  maxLength: '{{fieldName}} is too long',
};

export default fieldValidation;
